import { render, staticRenderFns } from "./TheWellboreMain.vue?vue&type=template&id=cd332d6a"
import script from "./TheWellboreMain.vue?vue&type=script&lang=ts"
export * from "./TheWellboreMain.vue?vue&type=script&lang=ts"
import style0 from "./TheWellboreMain.vue?vue&type=style&index=0&id=cd332d6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports